import React from "react";
import { useDesktopNav } from "./DesktopNavContext";
import "./desktopBack.css";

function Chevron() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="m15 6-6 6 6 6" />
    </svg>
  );
}

/** Desktop contextual return: "‹ Parent". */
export function DesktopBackLink({ onClick, label, className = "" }) {
  return (
    <button type="button" className={`cp-backlink ${className}`.trim()} onClick={onClick} aria-label={`Back to ${label}`}>
      <Chevron />
      <span>{label}</span>
    </button>
  );
}

/**
 * Drop-in replacement for the per-screen legacy Back buttons.
 *  - Mobile (or outside the desktop shell): renders the legacy button unchanged.
 *  - Desktop, `primary`: nothing (the sidebar is the navigation).
 *  - Desktop, otherwise: "‹ {label or parent}".
 */
export function ScreenBackButton({
  onBack,
  primary = false,
  label,
  legacyClassName = "cockpit-back-btn",
  legacyLabel = "Back",
  legacyProps = {},
}) {
  const nav = useDesktopNav();
  if (!onBack && !nav) return null;
  if (nav) {
    if (primary || !onBack) return null;
    return <DesktopBackLink onClick={onBack} label={label || nav.parentLabel || "Back"} />;
  }
  return (
    <button type="button" className={legacyClassName} onClick={onBack} {...legacyProps}>
      {legacyLabel}
    </button>
  );
}
